
import itMessages from '../locales/it_IT';

const ItLang = {
    messages: {
        ...itMessages
    },
    locale: 'it-IT',
    
};

export default ItLang;